import { type GetContractsResponse } from "@repo/api";
import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import { usePrimaryAPIClient } from "../context/PrimaryAPIClient";
import { useQueryKeyFactory } from "../context/QueryKeyProvider";

type IContracts = {
    options?: UseQueryOptions<GetContractsResponse[]>;
};

export const useContracts = ({ options }: IContracts = {}) => {
    const { contractsApi } = usePrimaryAPIClient();
    const { createQueryKey } = useQueryKeyFactory();
    return useQuery<GetContractsResponse[]>({
        queryKey: createQueryKey({ key: ["getContracts"] }),
        queryFn: () => {
            return contractsApi.getContractsGet();
        },
        ...options,
    });
};

type IContractByIdProps = {
    id: string;
    options?: Partial<UseQueryOptions<GetContractsResponse[], unknown, GetContractsResponse>>;
};

export const useContractById = ({ id, options }: IContractByIdProps) => {
    const { contractsApi } = usePrimaryAPIClient();
    const { createQueryKey } = useQueryKeyFactory();

    return useQuery<GetContractsResponse[], unknown, GetContractsResponse>({
        // Do not include contract id, it will lead to unnecessary refetching.
        queryKey: createQueryKey({ key: ["getContracts"] }),
        queryFn: () => {
            return contractsApi.getContractsGet();
        },
        ...{
            select: (data) => data.find((contract) => contract.id === id)!,
            ...options,
        },
    });
};
